"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _consts = require("../primitives/IllustrationPrimitive/consts");
var _IllustrationPrimitive = _interopRequireDefault(require("../primitives/IllustrationPrimitive"));
const Illustration = ({
  size = _consts.SIZE_OPTIONS.MEDIUM,
  ...props
}) => /*#__PURE__*/React.createElement(_IllustrationPrimitive.default, (0, _extends2.default)({}, props, {
  size: size
}));
var _default = Illustration;
exports.default = _default;